import axios, { AxiosRequestConfig } from 'axios';
import { Config } from './config/config';

export const axiosDefaults: AxiosRequestConfig = {
  baseURL: Config.apiRoot,
  withCredentials: true
};

export const axiosInstance = axios.create(axiosDefaults);
